/**
 * Tiny logger wrapper. No-ops in production builds, forwards to console.* in
 * dev. Exists so we can later swap in a real telemetry sink (Sentry, etc.)
 * without touching call sites.
 */
type Level = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_ORDER: Record<Level, number> = { debug: 0, info: 1, warn: 2, error: 3 };
const minLevel = (import.meta.env.VITE_LOG_LEVEL ?? 'warn') as Level;
const threshold = LEVEL_ORDER[minLevel] ?? LEVEL_ORDER.warn;

function emit(level: Level, args: unknown[]): void {
  if (LEVEL_ORDER[level] < threshold) return;
  // eslint-disable-next-line no-console
  console[level === 'debug' ? 'log' : level](...args);
}

export const log = {
  debug: (...a: unknown[]) => emit('debug', a),
  info: (...a: unknown[]) => emit('info', a),
  warn: (...a: unknown[]) => emit('warn', a),
  error: (...a: unknown[]) => emit('error', a),
};
